import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {JwtDecoderService} from './jwt-decoder.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
    constructor(public jwtHelper: JwtDecoderService, public router: Router,
                private httpClient: HttpClient) {
    }

    canActivate(): boolean {
        if (!this.jwtHelper.isAuthenticated()) {
            this.router.navigate(['login']);
            return false;
        }
        return true;
    }

    public logout() {
        return this.httpClient.get('api/v1/logout').toPromise();
    }
}
